import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, Collapsible, Divider, StateConfigContext, Typography, WHITE, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useContext, useRef, useState } from 'react';
import { View, Image } from 'react-native';
import { getStatusCardCollapsibleSectionStyles } from './StatusCardCollapsibleSectionStyles';
export var StatusCardCollapsibleSection = props => {
  var _props$collapsibleDat = props.collapsibleData,
    collapsibleData = _props$collapsibleDat === void 0 ? [] : _props$collapsibleDat,
    _props$collapsibleCta = props.collapsibleCtaData,
    collapsibleCtaData = _props$collapsibleCta === void 0 ? {} : _props$collapsibleCta,
    innerStyle = props.innerStyle,
    id = props.id,
    onUserAction = props.onUserAction,
    testID = props.testID,
    isExpanded = props.isExpanded;
  var _collapsibleCtaData$e = collapsibleCtaData.expandedCtaTitle,
    expandedCtaTitle = _collapsibleCtaData$e === void 0 ? '' : _collapsibleCtaData$e,
    _collapsibleCtaData$c = collapsibleCtaData.collapseCtaTitle,
    collapseCtaTitle = _collapsibleCtaData$c === void 0 ? '' : _collapsibleCtaData$c,
    _collapsibleCtaData$t = collapsibleCtaData.type,
    type = _collapsibleCtaData$t === void 0 ? 'tertiary' : _collapsibleCtaData$t,
    _collapsibleCtaData$v = collapsibleCtaData.version,
    version = _collapsibleCtaData$v === void 0 ? 'variable-width' : _collapsibleCtaData$v,
    onPressCta = collapsibleCtaData.onPressCta,
    _collapsibleCtaData$e2 = collapsibleCtaData.expandedCtaIconName,
    expandedCtaIconName = _collapsibleCtaData$e2 === void 0 ? 'UpChevronIcon' : _collapsibleCtaData$e2,
    _collapsibleCtaData$c2 = collapsibleCtaData.collapseCtaIconName,
    collapseCtaIconName = _collapsibleCtaData$c2 === void 0 ? 'DownChevronIcon' : _collapsibleCtaData$c2,
    _collapsibleCtaData$s = collapsibleCtaData.showCollapseExpandedCtaIcon,
    showCollapseExpandedCtaIcon = _collapsibleCtaData$s === void 0 ? false : _collapsibleCtaData$s;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var statusCardCollapsibleSectionStyles = getStatusCardCollapsibleSectionStyles();
  var _useState = useState(false),
    isCollapsibleOpen = _useState[0],
    setIsCollapsibleOpen = _useState[1];
  var collapsibleRef = useRef(null);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var collapsibleToggle = () => {
    var _a;
    (_a = collapsibleRef === null || collapsibleRef === void 0 ? void 0 : collapsibleRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPressCta), {
      ctaTitle: isCollapsibleOpen ? expandedCtaTitle : collapseCtaTitle
    });
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Collapsible, Object.assign({
      ref: collapsibleRef,
      showIcon: false,
      version: "fixed-padding",
      collapseContainerStyles: statusCardCollapsibleSectionStyles.container,
      titleNoHorizontalPadding: true,
      titleNoVerticalPadding: true,
      childNoHorizontalPadding: true,
      childNoVerticalPadding: true,
      isExpanded: isExpanded
    }, getTestId(testID, 'collapsible_container'), {
      children: [_jsx(Divider, Object.assign({
        style: statusCardCollapsibleSectionStyles.topMargin,
        height: 2,
        shadowColor: WHITE,
        theme: theme
      }, getTestId(testID, 'divider'))), _jsx(View, Object.assign({
        style: [statusCardCollapsibleSectionStyles.innerContainer, innerStyle]
      }, getTestId(testID, 'collapsible_section'), {
        children: collapsibleData === null || collapsibleData === void 0 ? void 0 : collapsibleData.map((item, index) => {
          var _item$title = item.title,
            title = _item$title === void 0 ? '' : _item$title,
            _item$value = item.value,
            value = _item$value === void 0 ? '' : _item$value,
            _item$imageUrl = item.imageUrl,
            imageUrl = _item$imageUrl === void 0 ? '' : _item$imageUrl,
            _item$actionCta = item.actionCta,
            actionCta = _item$actionCta === void 0 ? '' : _item$actionCta,
            _item$actionCtaSize = item.actionCtaSize,
            actionCtaSize = _item$actionCtaSize === void 0 ? '' : _item$actionCtaSize,
            _item$iconName = item.iconName,
            iconName = _item$iconName === void 0 ? '' : _item$iconName,
            onActionCtaPressMetaData = item.onActionCtaPressMetaData,
            _item$collapsibleData = item.collapsibleDataAccessibilityProps,
            collapsibleDataAccessibilityProps = _item$collapsibleData === void 0 ? {} : _item$collapsibleData,
            _item$valueAccessibil = item.valueAccessibilityProps,
            valueAccessibilityProps = _item$valueAccessibil === void 0 ? {} : _item$valueAccessibil,
            _item$actionCtAccessi = item.actionCtAccessibilityProps,
            actionCtAccessibilityProps = _item$actionCtAccessi === void 0 ? {} : _item$actionCtAccessi;
          return _jsxs(View, Object.assign({
            style: statusCardCollapsibleSectionStyles.row
          }, {
            children: [_jsxs(View, Object.assign({
              style: statusCardCollapsibleSectionStyles.rowContent
            }, collapsibleDataAccessibilityProps, {
              children: [!!title && _jsx(Typography, Object.assign({
                color: BLACK_700,
                type: 'body-single-line-xs',
                text: title
              }, getTestId(testID, 'title'), {
                accessible: !isValidObject(collapsibleDataAccessibilityProps)
              })), !!value && _jsx(Typography, Object.assign({
                type: 'body-para-sm-bold',
                color: BLACK_900,
                text: value,
                style: statusCardCollapsibleSectionStyles.subtitle
              }, getTestId(testID, 'value'), {
                accessible: !isValidObject(collapsibleDataAccessibilityProps)
              }, valueAccessibilityProps))]
            })), (!!imageUrl || !!actionCta) && _jsxs(View, Object.assign({
              style: statusCardCollapsibleSectionStyles.actions
            }, {
              children: [!!imageUrl && _jsx(Image, Object.assign({
                source: {
                  uri: imageUrl,
                  height: 36,
                  width: 36
                },
                resizeMode: "contain"
              }, getTestId(testID, 'imageUrl'))), !!actionCta && _jsx(Button, Object.assign({}, getTestId(testID, 'actionCta'), {
                buttonType: "tertiary",
                size: actionCtaSize ? actionCtaSize : isLargeScreen ? 'md' : 'sm',
                title: actionCta,
                iconName: iconName,
                onPress: () => {
                  isValidObject(onActionCtaPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                    id
                  }, onActionCtaPressMetaData), {
                    actionCta
                  }));
                }
              }, actionCtAccessibilityProps, {
                theme: theme
              }))]
            }))]
          }), "status_card_collapsible_" + title + "_" + index);
        })
      }))]
    })), !!collapsibleCtaData && Object.keys(collapsibleCtaData).length > 0 && _jsx(Button, Object.assign({}, getTestId(testID, 'collapsibleCta'), {
      size: isLargeScreen ? 'lg' : 'md',
      style: statusCardCollapsibleSectionStyles.topMargin,
      buttonType: type,
      version: version,
      title: isCollapsibleOpen ? expandedCtaTitle : collapseCtaTitle,
      onPress: () => {
        collapsibleToggle();
        setIsCollapsibleOpen(!isCollapsibleOpen);
      }
    }, showCollapseExpandedCtaIcon && {
      iconPosition: 'right',
      iconName: isCollapsibleOpen ? expandedCtaIconName : collapseCtaIconName
    }, isCollapsibleOpen ? Object.assign({}, collapsibleCtaData === null || collapsibleCtaData === void 0 ? void 0 : collapsibleCtaData.expandedCtaAccessibilityProps) : Object.assign({}, collapsibleCtaData === null || collapsibleCtaData === void 0 ? void 0 : collapsibleCtaData.collapseCtaAccessibilityProps), {
      theme: theme
    }))]
  });
};